import $api from "../http";
import { AxiosResponse, AxiosRequestConfig } from "axios";

export default class apiService {
  static async fetchEntity<T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    return $api.get<T>(url, config);
  }

  static async POST<T>(url: string, data: any): Promise<AxiosResponse<T>> {
    return $api.post<T>(url, data);
  }
  static async createEntity<T>(
    url: string,
    data: any,
  ): Promise<AxiosResponse<T>> {
    return $api.post<T>(url, data);
  }

  static async updateEntity<T>(
    url: string,
    id: number,
    data: any,
  ): Promise<AxiosResponse<T>> {
    return $api.put<T>(`${url}/${id}`, data);
  }

  static async patchEntity<T>(
    url: string,
    id: number,
    data: any,
  ): Promise<AxiosResponse<T>> {
    return $api.patch<T>(`${url}/${id}`, data);
  }

  /** `S.2`: точный адрес — переключатель опроса станции. */
  static async PATCH<T>(url: string, data: any): Promise<AxiosResponse<T>> {
    return $api.patch<T>(url, data);
  }

  static async deleteEntity<T>(
    url: string,
    id: number,
    params?: Record<string, any>,
  ): Promise<AxiosResponse<T>> {
    return $api.delete<T>(`${url}/${id}`, { params });
  }

  /** `B.12`: удаление по точному адресу — например, `/org/:id/api-key`. */
  static async DELETE<T>(url: string): Promise<AxiosResponse<T>> {
    return $api.delete<T>(url);
  }

  static async exportFile(url: string, data: any): Promise<Blob> {
    const response = await $api.post(url, data, {
      responseType: "blob", // ← важно!
    });
    return response.data;
  }

  // src/services/apiService.ts

  // src/services/apiService.ts
  static async uploadFile<T = any>(
    url: string,
    file: File,
    purpose?: string,
    ID?: number, // ← добавили
  ): Promise<AxiosResponse<T>> {
    const formData = new FormData();
    formData.append("file", file);
    if (purpose) formData.append("purpose", purpose);
    if (ID) formData.append("ID", ID.toString()); // ← вот оно!
    return $api.post<T>(url, formData);
  }

  static async uploadFirmware(
    file: File,
    type: "ESP" | "STM" | "AC_control",
    replace: boolean = false,
    // `ОБН.3` (`АРХ-Н25`): изделие образа — без него сервер отвечает 400.
    product: string = "",
  ): Promise<
    AxiosResponse<{
      success?: boolean;
      conflict?: boolean;
      filename?: string;
      message?: string;
    }>
  > {
    const formData = new FormData();
    formData.append("firmware", file);

    const params = new URLSearchParams();
    params.append("type", type);
    if (product) {
      params.append("product", product);
    }
    if (replace) {
      params.append("replace", "true");
    }

    const url = `/upload-firmware?${params.toString()}`;
    console.log(url, "firmwareURL");

    // Настройка validateStatus, чтобы axios не выбрасывал ошибку на 409 Conflict
    return $api.post(url, formData, {
      validateStatus: function (status) {
        // Принимаем статусы 200 (успех) и 409 (конфликт)
        return status === 200 || status === 409;
      },
    });
  }
}
